import { request } from "./http";

export const clientsService = {
  list({ status, search, dataBlock } = {}) {
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    if (search) params.set("search", search);
    if (dataBlock) params.set("dataBlock", dataBlock);

    const qs = params.toString();
    return request(`/Clients${qs ? `?${qs}` : ""}`);
  },

  getById(id) {
    return request(`/Clients/${id}`);
  },

  create(payload) {
    return request("/Clients", { method: "POST", body: payload });
  },

  update(id, payload) {
    return request(`/Clients/${id}`, { method: "PUT", body: payload });
  },

  remove(id) {
    return request(`/Clients/${id}`, { method: "DELETE" });
  },

  dataBlocks() {
    return request("/Clients/data-blocks");
  },
};
